import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TravelDetailListingModel } from 'common/models/page-models/travel-reimbursement/travel-detail-model';
import { TravelReimbursementModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-data.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { TravelDetailGridWidgetService } from 'common/widget/travel-reimbursement/travel-detail-widget';
 
@Injectable({
    providedIn: 'root'
})
export class TravelDetailGridResolver extends GridResolver<TravelReimbursementModel, TravelDetailListingModel> {
    constructor(
        protected fs: TravelDetailGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}